import { makeStyles } from '@mui/styles';
import { Colors, FontWeight } from '../../../assets/styles';

const useStyles = makeStyles(() => ({
  label: {
    '&.MuiFormControlLabel-label':{
    fontWeight: FontWeight.Bold,
    fontSize: 16,
    color: Colors.Blue,
    marginLeft: 23,
    width: 'max-content',
    }
  },
  labelRoot: {
    margin: 0,
  },
  uncheckedLabel: {
    color: Colors.Gray6,
  },
}));

export default useStyles;